// src/components/FAQSchema.jsx
import React from "react";
import { Helmet } from "react-helmet";

const FAQSchema = ({ faqs }) => {
  // Gracefully exit loop if array items do not exist
  if (!faqs || faqs.length === 0) return null;

  // Defensive filtering: Ensure we only map valid objects containing text
  const validatedEntities = faqs.filter(faq => {
    if (!faq) return false;
    const questionText = faq.q || faq.question;
    const answerText = faq.a || faq.answer;
    return !!(questionText && questionText.trim() && answerText && answerText.trim());
  });

  if (validatedEntities.length === 0) return null;

  // Utility sanitizer to strip out structural HTML layout markers from strings
  const sanitizeString = (str) => {
    if (!str) return "";
    return str
      .replace(/<\/?[^>]+(>|$)/g, "") // Clean out bold or italic tags cleanly
      .replace(/"/g, '\\"') // Escape double quotes to prevent breakdown faults
      .trim();
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": validatedEntities.map((faq) => ({
      "@type": "Question",
      "name": sanitizeString(faq.q || faq.question), // FIXED: Programmatic key normalization support
      "acceptedAnswer": {
        "@type": "Answer",
        "text": sanitizeString(faq.a || faq.answer)
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default FAQSchema;
